import {ContainerStatusFilterFormValues, DataGridPageState, GridSort} from "@ots-frontend/ots-ui";
import {createAction} from "@reduxjs/toolkit";

export const setContainerStatusPageFilter = createAction<ContainerStatusFilterFormValues>("ui/container-status-page/setFilter");
export const setContainerStatusPageState = createAction<DataGridPageState>("ui/container-status-page/setState");
export const setContainerStatusPageStateCell = createAction<[col: number, row: number]>("ui/container-status-page/setStateCell");
export const setContainerStatusPageStateWidths = createAction<(number | undefined)[]>("ui/container-status-page/setStateWidths");
export const setContainerStatusPageStateSort = createAction<GridSort | undefined>("ui/container-status-page/setStateSort");
